export default __webpack_public_path__ + "static/media/NationalInsurance.7d3c86a9.svg";